import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Skeleton,
  Alert,
  Slider,
} from "@mui/material";
import { getText } from "../utils/texts";

const SendPage = ({ avatarUrl, minimalMessageDonation, username, question, setQuestion, setShowConfirmDialog, language, makePayment }) => {
  const [donationAmount, setDonationAmount] = useState(minimalMessageDonation);
  
  // Update donationAmount if minimalMessageDonation changes
  useEffect(() => {
    setDonationAmount(minimalMessageDonation);
  }, [minimalMessageDonation]);

  const handleSliderChange = (event, newValue) => {
    setDonationAmount(newValue);
    
    // Trigger haptic feedback when slider value changes
    if (window.Telegram && window.Telegram.WebApp) {
      // Determine feedback intensity based on slider position
      // For special values, use medium intensity
      if (newValue % 20 === 0) {
        const data = JSON.stringify({
          eventType: 'web_app_trigger_haptic_feedback',
          eventData: { 
            type: 'impact',
            impact_style: 'medium'
          }
        });
        
        // For web version
        if (window.parent) {
          window.parent.postMessage(data, 'https://web.telegram.org');
        }
        
        // For mobile/desktop version
        if (window.TelegramWebviewProxy) {
          window.TelegramWebviewProxy.postEvent(
            'web_app_trigger_haptic_feedback',
            JSON.stringify({ type: 'impact', impact_style: 'medium' })
          );
        }
        
        // For Windows Phone
        if (window.external && window.external.notify) {
          window.external.notify(data);
        }
      } else {
        // Default light feedback for normal movements
        const data = JSON.stringify({
          eventType: 'web_app_trigger_haptic_feedback',
          eventData: { 
            type: 'impact',
            impact_style: 'light'
          }
        });
        
        // For web version
        if (window.parent) {
          window.parent.postMessage(data, 'https://web.telegram.org');
        }
        
        // For mobile/desktop version
        if (window.TelegramWebviewProxy) {
          window.TelegramWebviewProxy.postEvent(
            'web_app_trigger_haptic_feedback',
            JSON.stringify({ type: 'impact', impact_style: 'light' })
          );
        }
        
        // For Windows Phone
        if (window.external && window.external.notify) {
          window.external.notify(data);
        }
      }
    }
  };

  return (
    <Box p={2}>
      <Box display="flex" alignItems="center" mb={2}>
        {avatarUrl ? (
          <Avatar src={avatarUrl} alt={username} sx={{ width: 56, height: 56, mr: 2 }} />
        ) : (
          <Skeleton variant="circular" width={56} height={56} sx={{ mr: 2 }} />
        )}
        {username ? (
          <Typography variant="h6">{username}</Typography>
        ) : (
          <Skeleton variant="text" width={150} />
        )}
      </Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        {getText("sendingMessageTo", language)} <b>{username}</b>. {getText("messageGuidelines", language)}
      </Alert>
      <TextField
        label={getText("yourQuestion", language)}
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        inputProps={{ maxLength: 250 }}
        sx={{ mb: 2 }}
      />
      {minimalMessageDonation <= 0 ? (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowConfirmDialog(true)}
          disabled={!question.trim()}
        >
          {getText("send", language)}
        </Button>
      ) : (
        <>
          <Box sx={{ width: "100%", mb: 2 }}>
            <Typography gutterBottom>
              {getText("donationAmount", language)}: {donationAmount} ⭐️
            </Typography>
            <Slider
              value={donationAmount}
              min={minimalMessageDonation}
              max={1000}
              step={1}
              onChange={handleSliderChange}
              valueLabelDisplay="auto"
              aria-labelledby="donation-slider"
            />
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => makePayment(donationAmount)}
            disabled={!question.trim()}
          >
            {getText("sendWithPayment", language)} {donationAmount} ⭐️
          </Button>
        </>
      )}
    </Box>
  );
};

export default SendPage;